import { memo, useState } from 'react';
import { Box, Button, Typography } from '@bymason-private/legacy-pattern-components';
import { GenerateConnectivityReportModal } from '../../modals/generate-connectivity-report-modal';

interface BreakdownHeaderProps {
  iccid?: string;
  onError: (error: string, code?: number) => void;
  onSuccess: (reportEmail: string) => void;
}

export default memo(function BreakdownHeader({ iccid, onError, onSuccess }: BreakdownHeaderProps) {
  const [showGenerateReportModal, setGenerateReportShowModal] = useState(false);

  const handleOpenGenerateReportModal = () => {
    setGenerateReportShowModal(true);
  };

  const handleCloseGenerateReportModal = () => {
    setGenerateReportShowModal(false);
  };

  return (
    <Box width='100%' pb={1.5}>
      <Box
        sx={{
          width: '100%',
          alignItems: 'baseline',
          display: 'flex',
          justifyContent: 'space-between',
          gap: 0.5,
        }}
      >
        <Typography variant='h5'>Breakdown {iccid ? `for SIM ${iccid}` : ''}</Typography>
        {!iccid && (
          <Button color='secondary' onClick={handleOpenGenerateReportModal} variant='contained'>
            Generate custom report
          </Button>
        )}
      </Box>
      {showGenerateReportModal && (
        <GenerateConnectivityReportModal
          onClose={handleCloseGenerateReportModal}
          onSuccess={onSuccess}
          onError={onError}
          open={true}
        />
      )}
    </Box>
  );
});
